import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import cls from 'classnames';
// import { languageMap } from '@/locale';
import Picture from '../Picture';
import Tag from '../Tag';
import { PayChannel, PayChannelFormatorMap } from '@/configs/constants';
import { useNavigate } from 'react-router-dom';

// 0：无、1：normal-一般商品、2：modal-模坑赏、3：hexapus-一番赏
enum ProductType {
  normal = 1,
  modal,
  hexapus,
}

const tagMap = {
  1: {
    text: 'base.stock',
    color: '#0989E2',
  },
  2: {
    text: 'base.preOrder',
    color: '#01CBB3',
  },
};

type ProductItemType = {
  /** @description 商品id */
  id?: number;
  /** @description 封面 */
  banner?: string;
  /** @description 预付价格 */
  pre_price?: number;
  /** @description 原价 */
  price?: number;
  /** @description 原价 */
  ori_price?: number;
  /** @description 支付方式(1:paypal,11:钻石) */
  pay_channel?: number;
  /** @description 商品标题 */
  title?: string;
  /** @description 图片 */
  img?: string[];
  /** @description 在普通商品 商品类型(1:普通商品,2:预售商品) */
  type?: number;
  /** @description 尾款价格 */
  final_price?: number;
  /** @description 分类类型（0：无、1：normal-一般商品、2：modal-模坑赏、3：hexapus-一番赏 */
  class_type?: number;
  /** @description 已抽数量 */
  sales?: number;
  /** @description 剩余数量 */
  stock?: number;
  total?: number;
  // 分类ID
  classid?: number;
};

interface Props {
  info: ProductItemType;
  className?: string;
  descClassName?: string;
}

const ProductItem: React.FC<Props> = ({ info, className, descClassName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // const class_type = info.class_type !== undefined ? info.class_type : info.type;
  const isNormalProduct =
    !info.class_type || info.class_type === ProductType.normal;
  const tag = isNormalProduct ? tagMap[info.type!] : '';
  const isDiscounted = info.ori_price && info.ori_price !== info.price;
  const priceFormator = PayChannelFormatorMap.get(
    isNormalProduct ? info.pay_channel! : PayChannel.Gold,
  );

  const handleLinkToDetail = () => {
    if (info.class_type === ProductType.normal) {
      navigate(
        `/product/${info.id}${info.classid ? `?kindId=${info.classid}` : ''}`,
      );
    } else if (info.class_type === ProductType.modal) {
      navigate(`/product/hexakuji/${info.id}`);
    } else if (info.class_type === ProductType.hexapus) {
      navigate(`/product/ichiban/${info.id}`);
    }
  };

  return (
    <div className={cls(styles.item, className)} onClick={handleLinkToDetail}>
      <Picture
        src={info.banner ? info.banner! : info.img ? info.img![0] : ''}
        heightEqualWidth
        className={isNormalProduct && (info.stock ?? 0) <= 0 ? 'nostock' : ''}
      />
      <div className={cls(descClassName, styles.desc)}>
        <div className={styles.title}>{info.title}</div>
        <div className={styles.extraInfo}>
          <div
            className={cls(styles.price, {
              [styles.discountedPrice]: isDiscounted,
            })}
          >
            {priceFormator?.(info.price) ?? 'error'}
            {isDiscounted && (
              <span className={styles.originPrice}>
                {priceFormator?.(info.ori_price)}
              </span>
            )}
          </div>
          {info.class_type === ProductType.hexapus && (
            <span className={styles.count}>
              <span className={styles.line}>
                {info.stock ?? 0 - (info.sales ?? 0)}
              </span>
              /{info.total || '??'}
            </span>
          )}
        </div>
        {tag && <Tag title={t(tag.text)} color={tag.color} />}
      </div>
    </div>
  );
};

export default ProductItem;
